import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ModalClose from './ModalClose.jsx';

/**
 * Petite modale d'onboarding réutilisable (tip ponctuel, "vu" persisté côté serveur).
 * Props : emoji, title, children (corps), buttonLabel, onClose.
 * NB : bouton, croix et clic sur l'overlay font TOUS `onClose` — pour un onboarding
 * en plusieurs écrans, `onClose` de l'écran N passe à l'écran N+1 (sortir en croix
 * ne doit pas court-circuiter la suite).
 */
export default function OnboardingModal({ emoji, title, children, buttonLabel = 'Compris !', onClose }) {
  return (
    <AnimatePresence>
      <motion.div
        className="onboarding-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="onboarding-modal"
          onClick={(e) => e.stopPropagation()}
          initial={{ scale: 0.7, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.7, opacity: 0 }}
          transition={{ type: 'spring', damping: 14, stiffness: 200 }}
        >
          <ModalClose onClick={onClose} />
          <div className="onboarding-emoji">{emoji}</div>
          <h2 className="onboarding-title">{title}</h2>
          <div className="onboarding-body">{children}</div>
          <button className="btn btn-primary onboarding-btn" onClick={onClose}>
            {buttonLabel}
          </button>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
